module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAc0lEQVR42u3QURGAQABCQSpYwj6msp2VuC9TsMy8AGzaZrnp8wAAAAAAAAAAAAAAtPmuu0sBAAAAAAAAAAAAAAAAwN/aAAAAAAAAAAAAAAAAAKDJ+3QpAAAAAAAAAAAAAAAAAACwHAAAAAAAAAAAAAAAox3PpCAtVEHDbQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Hungary.png
// module id = DIRy
// module chunks = 0 62 63